import { EntityType } from "@feed-factory/feed-factory.models.ndtrc";

export const generateItemApiUrl = (
  eventType: EntityType,
  itemId: string,
  rev?: string | null
) => {
  // Determine url based on item type
  let url;
  if (eventType === "EVENEMENT") {
    url = `/events/${itemId}`;
  } else {
    url = `/locations/${itemId}`;
  }
  if (rev) {
    url += `?_rev=${rev}`;
  }
  return url;
};
